export const INFO_PATIENT_PAGE_ALERTS = 'INFO_PATIENT_PAGE_ALERTS'
